import { motion } from 'framer-motion';
import styled from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants, spin360Keyframes } from '@pkg/motion';
import { floorGameDuration as duration, floorGameEasing as easing, styledLayout, styledReset } from '@pkg/primitives';

interface WrapperProps {
    $size?: number;
}

export const Wrapper = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})<WrapperProps>`
    ${styledReset.borderBox};
    font-size: ${({ $size = 16 }) => $size}px;
`;

export const Spinner = styled.div`
    width: 1em;
    height: 1em;
    border: 0.125em solid rgb(255, 255, 255, 0.2);
    border-top: 0.125em solid currentColor;
    border-radius: 50%;
    animation: ${spin360Keyframes} ${duration.crawl}ms ${easing.cubic} infinite both;
`;

export const HiddenLabel = styled.p`
    ${styledReset.typography};
    ${styledLayout.visuallyHidden};
`;
